/**
 * FindOrCreateEventForm constants
 */
export const FORM_NAME = 'findOrCreateEventForm';
